import { EPosition } from '../../types/filters';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EFiltersActionType, TSetFiltersPosition } from './types';

export const setFiltersPosition: (position: EPosition) => TSetFiltersPosition = actionGenerator<
  EFiltersActionType.SetFiltersPosition,
  EPosition
>(EFiltersActionType.SetFiltersPosition);
